import { Component, TemplateRef, ViewChild } from '@angular/core';
import { TourMatMenuModule, TourService } from 'ngx-ui-tour-md-menu';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'maporium-tour-step-template',
  template: `
    <ng-template #customTemplate let-step="step">
      <mat-card
        [class]="'tour-step-card ' + step.anchorId"
        (click)="$event.stopPropagation()"
        [style.width]="step.stepDimensions?.width"
        [style.min-width]="step.stepDimensions?.minWidth"
        [style.max-width]="step.stepDimensions?.maxWidth">
        <mat-card-header>
          <div class="header-group">
            <mat-card-title class="w-100 text-center">
              {{ step.title }}
            </mat-card-title>
            <button
              mat-icon-button
              (click)="tourService.end()"
              class="close"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </mat-card-header>

        <mat-card-content class="mat-body">
          <div class="content" style="font-size: 20px" [innerHTML]="step.content">
          </div>
        </mat-card-content>

        <mat-card-actions
          [class.no-progress]="!step.showProgress">
          <button
            class="prev dialog-action-btn dialog-action-btn-cancel"
            [ngClass]="{'no-prev': !tourService.hasPrev(step)}"
            [disabled]="!tourService.hasPrev(step)"
            (click)="tourService.prev()">
            BACK
          </button>
          @if (step.showProgress) {
            <div class="progress-count">
              {{ tourService.steps!.indexOf(step) + 1 }} / {{ tourService.steps!.length }}
            </div>
          }
          @if (tourService.hasNext(step) && !step.nextOnAnchorClick) {
            <button
              class="next dialog-action-btn dialog-action-btn-primary"
              (click)="tourService.next()">
              {{ step.nextBtnTitle }}
            </button>
          }
          @if (!tourService.hasNext(step)) {
            <button
              class="end-btn dialog-action-btn dialog-action-btn-primary"
              (click)="tourService.end()">
              {{ step.endBtnTitle }}
            </button>
          }
        </mat-card-actions>
      </mat-card>
    </ng-template>
  `,
  standalone: true,
  styleUrls: ['./tour-step-template.component.scss'],
  imports: [
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    CommonModule,
    RouterModule,
    TourMatMenuModule,
  ]
})
export class TourStepTemplateComponent {
  // Kept for backwards compatibility with callers that reference it by name;
  // the tour is now auto-presented only on the user's very first sign-in
  // (see FIRST_SIGNIN_TOUR_KEY in dashboard.component.ts) and can be re-run
  // at any time from the help menu (MAP-1245).
  static readonly SHOW_TOUR_KEY = 'showTour';
  @ViewChild('customTemplate', { static: true }) customTemplate!: TemplateRef<any>;

  constructor(public tourService: TourService) {
  }
}
